<template>
  <div class="my_notifications_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="created_at"
      default-sort-direction="desc"
      ref="table"
      pagination-simple
      per-page="15"
      :data="notificationsList"
      paginated
      checkable
      :checked-rows.sync="rows.checked"
      detailed
      :show-detail-icon="false"
      @click="openInfo"
    >
      <template slot-scope="props">
        <b-table-column label="Дата" :visible="true" field="created_at" :centered="false" sortable>
          <div>{{ props.row.created_at | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
        <b-table-column
          v-if="userRole === 'admin'"
          label="Информация"
          :visible="true"
          field="data.message"
          :centered="false"
          sortable
        >
          <div style="max-width: unset;">
            {{ props.row.data.message }}
            <span v-if="props.row.data.application">
              {{
                `ФИО: ${props.row.data.application.name};
                Телефон: ${props.row.data.application.phone};
                Комментарий: ${props.row.data.application.comment};
                Район: ${props.row.data.application.region};`
              }}
            </span>
          </div>
        </b-table-column>
        <b-table-column
          v-if="userRole === 'user'"
          label="Информация"
          :visible="true"
          field="data.message"
          :centered="false"
          sortable
        >
          <div style="max-width: unset;">
            {{ `${props.row.data[0].message}. ${calcEnd(props.row.data[0].course_id)}` }}
          </div>
        </b-table-column>
        <b-table-column
          v-if="userRole === 'leader' || userRole === 'leader_admin'"
          label="Информация"
          :visible="true"
          field="data.message"
          :centered="false"
          sortable
        >
          <div style="max-width: unset;">{{ props.row.data.message }}</div>
        </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <div class="table_actions">
          <button v-if="userRole === 'user'" class="delete_course" @click="$emit('open', props.row.data[0].course_id)">
            <i class="mdi mdi-folder-open-outline"></i> Открыть курс
          </button>
          <button class="delete_course" @click="$emit('delete', props.row)">
            <i class="mdi mdi-delete"></i> Удалить
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    notificationsList: {
      default: () => [],
      type: Array
    },
    isLoading: {
      default: () => true,
      type: Boolean
    },
    rows: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
    rightCoursesList() {
      return this.$store.state.courses.userRightCoursesList.courses
    }
  },
  methods: {
    calcEnd(cid) {
      let currentCourse = this.rightCoursesList.find((el) => el.id === cid)
      if (!currentCourse) return ''
      return (
        'Курс можно пройти до ' +
        this.$moment(currentCourse.date_start).add(currentCourse.days_limit, 'days').format('DD.MM.YYYY')
      )
    },
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow)
        this.$refs.table.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.table.toggleDetails(row)
      this.openedRow = {}
    }
  }
}
</script>
